import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

import { ComparisonDirective } from './comparison.directive';
export class EqualToDirective extends ComparisonDirective {
public ngEqualTo: any;
constructor() {
    super('ngEqualTo');
  }
/**
 * @param {?} control
 * @return {?}
 */
validateCore(control: AbstractControl): boolean {
    return control.value === this.ngEqualTo;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngEqualTo]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EqualToDirective,
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngEqualTo': [{ type: Input },],
};
}

function EqualToDirective_tsickle_Closure_declarations() {
/** @type {?} */
EqualToDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EqualToDirective.ctorParameters;
/** @type {?} */
EqualToDirective.propDecorators;
/** @type {?} */
EqualToDirective.prototype.ngEqualTo;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
